export const REQUEST_ACCOUNT_DELETION_MUTATION = `
  mutation RequestAccountDeletionMutation {
    me {
      requestAccountDeletion
    }
  }
`;
